import { SVGProps } from 'react'

export const Code = ({
  size = 24,
  className,
  ...props
}: SVGProps<SVGSVGElement> & { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.25 2.25H21.75V21.75H2.25V2.25ZM3.75 3.75V20.25H20.25V3.75H3.75ZM6.81818 6.30298L9.78793 9.27273L6.81818 12.2425L5.75752 11.1818L7.66661 9.27273L5.75752 7.36364L6.81818 6.30298ZM9.88636 10.4318H13.5682V11.9318H9.88636V10.4318Z"
      fill="currentColor"
    />
  </svg>
)

